import { Tab, TabProps, useTheme } from "@mui/material";
import { a11yProps } from "../../features/TabPanel/TabPanel.partial";

interface CustomColoredTabProps extends TabProps {
  index: number;
  "data-testid"?: string;
  label: string;
}

export const CustomColoredTab = ({
  index,
  "data-testid": dataTestId,
  label,
  sx,
  ...tabProps
}: CustomColoredTabProps) => {
  const theme = useTheme();

  return (
    <Tab
      disableRipple
      label={label}
      data-testid={dataTestId ?? (typeof label === "string" ? label : undefined)}
      {...tabProps}
      {...a11yProps(index)}
      sx={{
        ...sx,
        fontWeight: theme.typography.fontWeightRegular,
        "&.Mui-selected": {
          color:
            theme.palette.mode === "dark"
              ? theme.palette.getContrastText(theme.palette.background.paper)
              : theme.palette.primary.main,
          fontWeight: theme.typography.fontWeightBold
        }
      }}
    />
  );
};
